import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=d4829880&scoped=true&"
import script from "./PropertyDetail.vue?vue&type=script&lang=js&"
export * from "./PropertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&id=d4829880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4829880",
  null
  
)

export default component.exports